// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"debe38e4","990":"56ba6a4a"}[chunkId] + ".chunk.js";
};